module.exports = __webpack_public_path__ + "img/pingjia_pic.83925c29.png";